<template>
    <div>
        <Table border :columns="columnsTbale" :data="row" class="expand-table"></Table>
		<div v-if="createShow">
        <NewCustomer :value="createShow" :isAdd="isAdd" @close="close" :id="itemId" @getTabSon="getParentTab" />
		<!-- <NewCustomer :value="createShow" :isAdd="isAdd" @close="close" :departmentType="$constDefinition.ODM事业部" :id="itemId" @getTab="getTab" :userData="userData" :provinceData="provinceData" :enterpriseNatureData="enterpriseNatureData" /> -->
		</div>
    </div>
</template>
<script>
import NewCustomer from './newcustomer.vue';
import { removeContact } from '../../api/index';
export default {
    props: {
        row: Array,
    },
    components: {
        NewCustomer,
    },
    data() {
        return {
            createShow: false,
            isAdd: '',
            itemId: 0,
            columnsTbale: [
                {
                    title: '联系人',
                    key: 'c联系人',
					width: 230,
                },
                {
                    title: '职位',
                    key: 'c职位',
					width: 230,
                },
                {
                    title: '电话',
                    key: 'c电话',
					width: 230,
                },
				{
				    title: '邮箱',
				    key: 'c邮箱',
					width: 230,
				},
                {
                    title: '操作',
                    align: 'left',
                    render: (h, params) => {
                        return h('div', [
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: () => {
                                            this.itemId = params.row.guid;
                                            this.isAdd = '编辑联系人';
                                            this.createShow = true;
                                        },
                                    },
                                },
                                '编辑'
                            ),
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'error',
                                        size: 'small',
                                    },
                                    on: {
                                        click: async () => {
                                            this.$Modal.confirm({
                                                title: '确定删除数据？',
                                                content: '删除后不可撤销',
                                                okText: '确认',
                                                cancelText: '取消',
                                                onOk: async () => {
                                                    let res = await removeContact(params.row.id);
                                                    if (res.data.success) {
                                                        this.$Message.success('删除成功');
                                                    } else {
                                                        this.$Message.success('删除失败');
                                                    }
                                                    this.$emit('getTab', params.row.customerId);
                                                },
                                            });
                                        },
                                    },
                                },
                                '删除'
                            ),
                        ]);
                    },
                },
            ],
        };
    },
    methods: {
        close() {
            this.createShow = false;
        },
        getParentTab(params) {
            console.log(params);
            this.$emit('getTab', params);
        },
    },
};
</script>

<style scoped lang="less">
.expand-table /deep/.ivu-table-wrapper {
    border-color: transparent;
}
/deep/ .ivu-table th,
.ivu-table td {
    border-bottom: 0;
}
</style>
